export const GET_SETTING_DELIVERY_FEES = "get_setting_delivery_fees";
export const SET_SETTING_DELIVERY_FEES = "set_setting_delivery_fees";
export const DEACTIVATE_SETTING_DELIVERY_FEE = "deactivate_setting_delivery_fee";
export const GET_DISTRIBUTOR_TARIFFS = "get_distributor_tariffs";
export const SET_DISTRIBUTOR_TARIFF = "set_distributor_tariff";
